import { render, staticRenderFns } from "./SuggestionModal.vue?vue&type=template&id=72273d44&"
import script from "./SuggestionModal.vue?vue&type=script&lang=ts&"
export * from "./SuggestionModal.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionModal.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports